module.exports = __webpack_public_path__ + "img/img-4.6a690276.png";